module.exports = __webpack_public_path__ + "static/media/square.92dddd75.svg";